import config from "@shared/config/client";
import {
  withAuthenticatedClientRequest,
  withClientRequest,
} from "@/api/requestBuilder/withClientRequest";
import { ICallableRequestBuilder } from "@/api/requestBuilder/types";
import { ArtOrderFull, ArtOrderUpdate } from "../types";
import requests from "./requests";
import queryString from "query-string";

const createArtOrder =
  (request: ICallableRequestBuilder<ArtOrderUpdate>) =>
  async (artOrder: ArtOrderUpdate) => {
    return request.call(`${config.apiUrl}/art-order/order`, (init) => ({
      ...init,
      method: "POST",
      headers: {
        ...init.headers,
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        title: artOrder.title,
        shortDescription: artOrder.shortDescription,
        detailedDescription: artOrder.detailedDescription,
        maxBudget: artOrder.maxBudget,
        budgetPaymentERC20TokenAddress: artOrder.budgetPaymentERC20TokenAddress,
        images: artOrder.images,
      }),
    }));
  };

const extendArtOrder =
  (request: ICallableRequestBuilder<ArtOrderUpdate>) =>
  async (orderId: string, timeframe: number) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/art-order/order/extend/${orderId}`,
      query: {
        timeframe,
      },
    });

    return request.call(url, (init) => ({
      ...init,
      method: "PUT",
    }));
  };

const updateOrderSignature =
  (request: ICallableRequestBuilder<ArtOrderUpdate>) =>
  async (orderId: string, signature: string) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/art-order/order/signature/${orderId}`,
      query: {
        signature,
      },
    });

    return request.call(url, (init) => ({
      ...init,
      method: "PUT",
    }));
  };

const updateArtOrder =
  (request: ICallableRequestBuilder<ArtOrderUpdate>) =>
  async (artOrder: ArtOrderUpdate) => {
    return request.call(
      `${config.apiUrl}/art-order/order/${artOrder.id}`,
      (init) => ({
        ...init,
        method: "PUT",
        headers: {
          ...init.headers,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          title: artOrder.title,
          shortDescription: artOrder.shortDescription,
          detailedDescription: artOrder.detailedDescription,
          maxBudget: artOrder.maxBudget,
          budgetPaymentERC20TokenAddress:
            artOrder.budgetPaymentERC20TokenAddress,
          images: artOrder.images,
        }),
      }),
    );
  };

const deleteArtOrder =
  (request: ICallableRequestBuilder<ArtOrderFull>) => (orderId: string) => {
    return request.call(
      `${config.apiUrl}/art-order/order/${orderId}`,
      (init) => ({
        ...init,
        method: "DELETE",
      }),
    );
  };

const clientRequests = {
  createArtOrder: withAuthenticatedClientRequest(createArtOrder),
  updateOrderSignature: withAuthenticatedClientRequest(updateOrderSignature),
  extendArtOrder: withAuthenticatedClientRequest(extendArtOrder),
  getArtOrder: withClientRequest(requests.getArtOrder),
  updateArtOrder: withAuthenticatedClientRequest(updateArtOrder),
  deleteArtOrder: withAuthenticatedClientRequest(deleteArtOrder),
};

export default clientRequests;
